/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ServiceAreaRuleArea
 */
export interface ServiceAreaRuleArea {
    /**
     * 
     */
    kind: ServiceAreaRuleAreaKindEnum;
    /**
     * 
     */
    geoid: string;
    /**
     * 
     */
    name: string;
}


/**
 * @export
 */
export const ServiceAreaRuleAreaKindEnum = {
    State: 'state',
    County: 'county',
    Town: 'town',
    Zip: 'zip',
    Custom: 'custom',
} as const;
export type ServiceAreaRuleAreaKindEnum = typeof ServiceAreaRuleAreaKindEnum[keyof typeof ServiceAreaRuleAreaKindEnum];


/**
 * Check if a given object implements the ServiceAreaRuleArea interface.
 */
export function instanceOfServiceAreaRuleArea(value: object): value is ServiceAreaRuleArea {
    if (!('kind' in value) || value['kind'] === undefined) return false;
    if (!('geoid' in value) || value['geoid'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function ServiceAreaRuleAreaFromJSON(json: any): ServiceAreaRuleArea {
    return ServiceAreaRuleAreaFromJSONTyped(json, false);
}

export function ServiceAreaRuleAreaFromJSONTyped(json: any, ignoreDiscriminator: boolean): ServiceAreaRuleArea {
    if (json == null) {
        return json;
    }
    return {
        
        'kind': json['kind'],
        'geoid': json['geoid'],
        'name': json['name'],
    };
}

export function ServiceAreaRuleAreaToJSON(json: any): ServiceAreaRuleArea {
    return ServiceAreaRuleAreaToJSONTyped(json, false);
}

export function ServiceAreaRuleAreaToJSONTyped(value?: ServiceAreaRuleArea | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'kind': value['kind'],
        'geoid': value['geoid'],
        'name': value['name'],
    };
}

